import React from "react";
import { useNavigate } from "react-router-dom";
import StatusPage from "./StatusPage";
import { AlertIcon } from "../../components/common/Icons/Icons";

const ErrorPage: React.FC<{error:any}> = ({error}) => {
    const navigate = useNavigate();
    const text = String(error ?? '');
    // A dead session can only be fixed by signing in again
    const sessionExpired = text.includes('JWT Error:');

    return (
        <StatusPage
            code="Error"
            title={sessionExpired ? "Session expired" : "Something went wrong"}
            message={sessionExpired ? "Please log in again to continue." : text || "An unexpected error occurred."}
            icon={<AlertIcon/>}
            withHome={!sessionExpired}
            actions={sessionExpired &&
                <a href="/login" className="btn btn-primary" onClick={(e) => { e.preventDefault(); navigate('/login'); }}>
                    Log in
                </a>}
        />
    );
};

export default ErrorPage;
